import store from '@/store'

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export  function checkPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    const roles = this.$store.getters && this.$store.getters.roles
    const permissionRoles = value

    const hasPermission = roles.some(role => {
      return permissionRoles.includes(role)
    })

    if (!hasPermission) {
      return false
    }
    return true
  } else {
    return false
  }
}
export  function handlePermission(value){
    if(value != null && value != undefined && value != 'undefined' && value != 'false' && value != ''){
      return true
    }else{
      return false
    }
}

